export default {
	GUIDED_TOUR_SHOW: 'GUIDED_TOUR_SHOW',
	GUIDED_TOUR_HIDE: 'GUIDED_TOUR_HIDE',
};
